module.exports = __webpack_public_path__ + "static/img/filter.44952290.svg";